module.exports = __webpack_public_path__ + "media/images/emblems/Nyon-coat_of_arms-95da7f250387ee2d8cbaa35263eb932a.svg";